import { useEffect, useState } from "react";

/**
 * The time since `since`, or since the caller mounted when there is none, as m:ss, ticking
 * once a second.
 *
 * Read off the wall clock rather than counted per tick, so a background tab whose timers
 * the browser slows still shows the time that has passed.
 */
export function useElapsedClock(since?: string | null): string {
  const [started] = useState(() => {
    const at = since ? Date.parse(since) : Number.NaN;
    return Number.isNaN(at) ? Date.now() : at;
  });
  const [now, setNow] = useState(Date.now);
  useEffect(() => {
    const tick = setInterval(() => {
      setNow(Date.now());
    }, 1000);
    return () => {
      clearInterval(tick);
    };
  }, []);
  // A server clock a little ahead of this one must not read as negative time.
  const seconds = Math.max(0, Math.floor((now - started) / 1000));
  return `${String(Math.floor(seconds / 60))}:${String(seconds % 60).padStart(2, "0")}`;
}
